import { render, staticRenderFns } from "./policyWrap.vue?vue&type=template&id=03589ffc&scoped=true&"
import script from "./policyWrap.vue?vue&type=script&lang=js&"
export * from "./policyWrap.vue?vue&type=script&lang=js&"
import style0 from "./policyWrap.vue?vue&type=style&index=0&id=03589ffc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03589ffc",
  null
  
)

export default component.exports